module.exports = __webpack_public_path__ + "img/visit.5c27488e.svg";